
/* Oct 19 (Jacob): Log Cabin landing page at /pages/log-cabin (view 'logcabin'). No Shopify product yet,
   so shop buttons read "Coming soon" and the CTAs open the Klaviyo list form. Wire add-to-cart once variants exist. */
(function(){
  window.lcScrollShop=function(){var e=document.getElementById('lc-shop');if(e)e.scrollIntoView({behavior:'smooth'})};
  if(!window.ccNotify)window.ccNotify=function(){try{(window._klOnsite=window._klOnsite||[]).push(['openForm','UL8Dad'])}catch(e){}};
  var on=false;
  function flakes(){
    var box=document.querySelector('#view-logcabin .lc-snow');if(!box||box.childElementCount)return;
    if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    var n=window.innerWidth<700?10:18,h='';
    for(var i=0;i<n;i++){var sz=10+Math.round(Math.random()*14);h+='<span class="lc-flake" style="left:'+(Math.random()*100).toFixed(1)+'%;width:'+sz+'px;height:'+sz+'px;animation-duration:'+(10+Math.random()*10).toFixed(1)+'s;animation-delay:-'+(Math.random()*18).toFixed(1)+'s"></span>'}
    box.innerHTML=h;
  }
  function vids(){document.querySelectorAll('#view-logcabin video[data-src]').forEach(function(v){if(!v.getAttribute('src')){v.setAttribute('src',v.getAttribute('data-src'))}var p=v.play();if(p&&p.catch)p.catch(function(){})})}
  setInterval(function(){var now=window.current==='logcabin';if(now&&!on){flakes();vids()}on=now},500);
})();
